import type { ListingsAPIErrorResponseBody } from '../../common/types/ListingsAPIErrorResponseBody';

export const listingsResponse500: ListingsAPIErrorResponseBody = {
  statusCode: 500,
  message: 'Internal server error',
};
